"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardListaResultadoBusca = void 0;
var react_1 = __importDefault(require("react"));
var Cores_1 = require("../Cores/Cores");
var Card_1 = require("../Card/Card");
var ListaConteudo_1 = require("./ListaConteudo/ListaConteudo");
var cardListaResultadoBuscaModule = require("./CardListaResultadoBusca.module.scss");
var CardListaResultadoBusca = function (_a) {
    var cabecalho = _a.cabecalho, itens = _a.itens, quantidadeTotalItens = _a.quantidadeTotalItens, paginaAtual = _a.paginaAtual, quantidadePorPagina = _a.quantidadePorPagina, quantidadePaginas = _a.quantidadePaginas, avisoNenhumResultado = _a.avisoNenhumResultado, opcoesItensPorPagina = _a.opcoesItensPorPagina, itemChildren = _a.itemChildren, onChangePagina = _a.onChangePagina, onChangeQuantidadePorPagina = _a.onChangeQuantidadePorPagina;
    return (react_1.default.createElement(Card_1.Card, { style: {
            width: "auto",
            height: "100%",
        }, corDeFundo: Cores_1.Cores.CoresIdentidadeMU.brancoMu },
        cabecalho,
        itens.length === 0 ? avisoNenhumResultado :
            react_1.default.createElement(ListaConteudo_1.ListaConteudo, { itens: itens, paginaAtual: paginaAtual, quantidadeTotalItens: quantidadeTotalItens, quantidadePorPagina: quantidadePorPagina, onChangePagina: onChangePagina, onChangeQuantidadePorPagina: onChangeQuantidadePorPagina, quantidadePaginas: quantidadePaginas, opcoesItensPorPagina: opcoesItensPorPagina, itemChildren: itemChildren })));
};
exports.CardListaResultadoBusca = CardListaResultadoBusca;
